module.exports = __webpack_public_path__ + "static/img/logo_title.c35b4d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_title.png
// module id = Yh9l
// module chunks = 0